var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEyeOpen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.329 9.19718C16.5122 6.05625 13.1278 4.10873 9.49997 4.10873C5.87217 4.10873 2.48778 6.05625 0.670909 9.19718C0.569983 9.38124 0.569983 9.60687 0.670909 9.79093C2.48778 12.9378 5.87217 14.8912 9.49997 14.8912C13.1278 14.8912 16.5122 12.9378 18.329 9.79093C18.43 9.60687 18.43 9.38124 18.329 9.19718V9.19718ZM9.49997 13.2109C7.45153 13.2109 5.78903 11.5484 5.78903 9.5C5.78903 7.45155 7.45153 5.78906 9.49997 5.78906C11.5484 5.78906 13.2109 7.45155 13.2109 9.5C13.2109 11.5484 11.5484 13.2109 9.49997 13.2109Z",
    fill: "#E6E6E6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 12.0234C10.8937 12.0234 12.0234 10.8937 12.0234 9.5C12.0234 8.10634 10.8937 6.97656 9.5 6.97656C8.10634 6.97656 6.97656 8.10634 6.97656 9.5C6.97656 10.8937 8.10634 12.0234 9.5 12.0234Z",
    fill: "#E6E6E6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeOpen);
export default __webpack_public_path__ + "static/media/eye_open.fb1bd78c5f0a0684f8ff538b13834987.svg";
export { ForwardRef as ReactComponent };